'use strict';

// Localisations
// ============
module.exports = {
  en: {
    name: 'Name',
    email: 'Email',
    password: 'Password',
    confirmpassword: 'Confirm Password',
    signupbutton: 'Create Account',
    loginbutton: 'Get Started',
    loginsignupbutton: 'Login',
    forgottenbutton: 'Forgotten',
    nameisrequired: 'A name is required',
    nonvalidemail: 'Doesn\'t look like a valid email.',
    noemail: 'What\'s your email address?',
    passwordminimum: 'Password must be at least 3 characters.',
    nonmatchpassword: 'Passwords must match.',
    enteremailandpassword: 'Please enter your email and password.',
    enteremail: 'Please enter a valid email.',
    send: 'Send',
    changePassword: 'Change Password',
    currentpassword: 'Current Password',
    newpassword: 'New Password',
    savebutton: 'Save',
    upload: 'Upload',
    profileimage: 'Profile Image',
    userdetails: 'User Details',
    title: 'Title',
    saveprofile: 'Save Profile',
    savechanges: 'Save Changes',
    savepassword: 'Change Password',
    choosealocation: 'Choose Primary Location',
    iamteacher: "I am a teacher",
    iamstudent: "I am a student",
    iamparent: "I am a parent",
    remainanonymous: "Remain Anonymous",
    agreeto: 'I agree to',
    houserules: 'the house rules',
    requestsent: 'We have emailed you a link.',
    activated: "Your account has been activated.",
    notactivated: "There is an issue activating your account. Please contact support.",
    checkyouremail: "Thanks for signing up.  We have sent you an email to confirm your email address.",
    hiderules: 'OK',
    pleaseagreetohr: "You must agree to the house rules to sign up.",
    pleasereadhr: 'Please read the house rules before agreeing to them.'
  },
  es: {

  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/account/account.localisations.js